module.exports = __webpack_public_path__ + "img/logo.d7ac4a18.png";